module.exports = __webpack_public_path__ + "img/notes.eec83d64.png";